module.exports = __webpack_public_path__ + "7e7c6292acd55f8295bb7d57b34aded5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/heldenkult_unclear.svg
// module id = 19
// module chunks = 0